module.exports = __webpack_public_path__ + "media/images/emblems/Puidoux-coat_of_arms-944a70a3437f634f63cacd371d93963a.svg";